import React from "react";
import { FeatureHighlightSection } from "./sections/FeatureHighlightSection";
import { FooterSection } from "./sections/FooterSection/FooterSection";
import { MainContentSection } from "./sections/MainContentSection";
import { MediaShowcaseSection } from "./sections/MediaShowcaseSection";
import { PricingSection } from "./sections/PricingSection";
import { TestimonialSection } from "./sections/TestimonialSection";
import { MobileMenu } from "../../components/MobileMenu/MobileMenu";
import { ScrollToTop } from "../../components/ScrollToTop/ScrollToTop";
import { motion, AnimatePresence } from "framer-motion";

export const Design = (): JSX.Element => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="bg-white flex flex-col items-center w-full"
      >
        <div className="bg-white w-full max-w-[1920px]">
          <MobileMenu />
          <ScrollToTop />
          <MediaShowcaseSection />
          <FeatureHighlightSection />
          <MainContentSection />
          <PricingSection />
          <TestimonialSection />
          <FooterSection />
        </div>
      </motion.div>
    </AnimatePresence>
  );
};